import React from 'react';
import { ChevronDown, ClipboardCheck, Landmark, Building2, Truck, UsersRound, Users, UserPlus, ListChecks } from 'lucide-react';

import Dropdown, { DropdownItem } from '../ui/Dropdown';
import Button from '../ui/Button';

export default function QuickActions({ announcementId, setAction, onAssignTeam, onAssignResponder, onManageRoster, onAssignHospital }) {
  const handleAssignTeam = () => {
    onAssignTeam();
  };

  const handleViewTeam = () => {
    setAction('assignTeam');
  };

  const handleViewResponses = () => {
    setAction('viewResponses');
  };

  const actions = [
    { icon: ClipboardCheck, name: 'View Responses', handler: handleViewResponses },
    { icon: Landmark, name: 'Involve Stakeholders', handler: handleAssignTeam },
    { icon: Building2, name: 'Prepare Hospital', handler: onAssignHospital },
    { icon: Truck, name: 'Assign Ambulance', handler: handleAssignTeam },
    { icon: UsersRound, name: 'Assign Team', handler: handleAssignTeam },
    { icon: UserPlus, name: 'Assign Responder', handler: onAssignResponder },
    { icon: ListChecks, name: 'Manage Roster', handler: onManageRoster },
    { icon: Users, name: 'View Teams', handler: handleViewTeam },
  ];

  return (
    <Dropdown
      align="right"
      trigger={({ toggle }) => (
        <Button variant="primary" size="md" onClick={toggle}>
          Quick Actions
          <ChevronDown className="w-4 h-4" />
        </Button>
      )}
    >
      {({ close }) =>
        actions.map((action) => (
          <DropdownItem
            key={action.name}
            icon={action.icon}
            onClick={() => {
              action.handler();
              close();
            }}
          >
            {action.name}
          </DropdownItem>
        ))
      }
    </Dropdown>
  );
}
